<template>
    <div class="certificate-main">
        <DefInput
            :placeholder="messages.number"
            v-model="certificate"
        />
        <DefButtonPrimary
            v-if="certificate.length"
            @click="handlerAddCertificate"
        >
            {{ messages.apply }}
        </DefButtonPrimary>
        <DefButtonSecondary
            v-else
            :disabled="true"
        >
            {{ messages.apply }}
        </DefButtonSecondary>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DefInput from "../../def/DefInput/DefInput";
import DefButtonPrimary from "../../def/DefButtonPrimary/DefButtonPrimary";
import DefButtonSecondary from "../../def/DefButtonSecondary/DefButtonSecondary";

export default {
    name: 'CertificateMain',
    components: {
        DefInput,
        DefButtonPrimary,
        DefButtonSecondary,
    },
    data() {
        return {
            isValid: true,
            certificate: '',
        }
    },
    computed: {
        ...mapState({
            messages: ({ basket }) => basket.data?.messages?.certificates,
        }),
    },
    methods: {
        ...mapActions({
            setCertificate: 'basket/setCertificate',
            setAjax: 'checkout/setAjax'
        }),
        async handlerAddCertificate() {
            const data = await this.setCertificate(this.certificate);

            if (data.error) {
                this.$emit('setError', {
                    ...data,
                    certificate: this.certificate,
                });
            } else {
                this.setAjax();
            }

            this.certificate = '';

            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.certificate-main{
    display: flex;
    flex-direction: column;
    padding: 4px 16px 24px;
    @include point-md{
        padding: 4px 24px 24px;
    }
    :deep(.def-input-component){
        margin-bottom: 24px;
    }
    :deep(.def-input-component__input){
        margin-bottom: 24px;
    }
}
</style>